import React from "react";

export const ImgContext = React.createContext();

export const ImgProvider = (props) => {
  const [img, setImg] = React.useState(
    "https://source.boomplaymusic.com/group10/M00/12/13/474abf0722d7419dad4d4053cb396d83_464_464.jpg"
  );

  return (
    <ImgContext.Provider value={[img, setImg]}>
      {props.children}
    </ImgContext.Provider>
  );
};
